"use strict";
for (const gallery of document.querySelectorAll('.sabra-gallery')) {
    const dialog = gallery.querySelector('.sabra-gallery__dialog');
    const dialogImageContainer = dialog === null || dialog === void 0 ? void 0 : dialog.querySelector('.sabra-gallery__dialog-image');
    const closeButton = dialog === null || dialog === void 0 ? void 0 : dialog.querySelector('.sabra-gallery__dialog-close');
    const imagesContainer = gallery.querySelector('.sabra-gallery__images');
    if (!dialog || !imagesContainer || !dialogImageContainer || !closeButton) {
        continue;
    }
    closeButton.addEventListener('click', () => {
        dialog.close();
    });
    function closeOnOutsideClick(event) {
        const clickedElement = event.target;
        /*	Only works if you click outside of the dialog, because of
            object-fit: contain; on the image, but better than nothing.*/
        if (!clickedElement.closest('.sabra-gallery__image')) {
            dialog === null || dialog === void 0 ? void 0 : dialog.close();
        }
    }
    dialog.addEventListener('close', () => {
        document.removeEventListener('click', closeOnOutsideClick);
        document.body.style.overflow = '';
    });
    imagesContainer.addEventListener('click', (event) => {
        const target = event.target;
        const clickeButton = target.closest('.sabra-gallery__button');
        if (!clickeButton) {
            return;
        }
        const clickedImage = clickeButton.querySelector('.sabra-gallery__image');
        if (!clickedImage) {
            return;
        }
        const clonedImage = clickedImage.cloneNode(true);
        // Might be narrower depending of aspect ratio of screen and image, but should work for most cases
        clonedImage.setAttribute('sizes', '80vw');
        dialogImageContainer.replaceChildren(clonedImage);
        dialog.showModal();
        // Prevent modal from immediately closing
        event.stopPropagation();
        document.addEventListener('click', closeOnOutsideClick);
        // stop window scrolling when modal is open
        document.body.style.overflow = 'hidden';
    });
}
